import React from 'react';
import { CardBody } from '../../components/CardBody';
import { CardFooter } from '../../components/CardFooter';
import { CardHeader } from '../../components/CardHeader';
import { CardTitle } from '../../components/CardTitle';
import { WhyHoneylove } from '../../sections/WhyHoneylove';
import { DiscoverHoneylove } from '../../sections/DiscoverHoneylove';
import { CollectionCards } from '../../collection/components/CollectionCards';
import { HomePageFadeCarousel } from '../../components/HomePageFadeCarousel';
import { WorldsBestShapingPanel } from '../../components/WorldsBestShapingPanel';
import { HoneyloveIRL } from '../../sections/HoneyloveIRL';
import { Link } from '../../root/components/Link';
import { WorldsBestTitle } from '../../components/WorldsBestTitle';
import HomePageSalePromo from '../../components/HomePageSalePromo';
import { useRecoilValue } from 'recoil';
import { environmentContextState } from '../../recoil/atoms';

export const HomeLanderDesktop: React.FC = () => {
  const environmentContext = useRecoilValue(environmentContextState);
  return (
    <>
      <CardBody>{environmentContext.timedSaleActive ? <HomePageSalePromo /> : <HomePageFadeCarousel />}</CardBody>
      <CardBody>
        <WorldsBestTitle />
      </CardBody>
      <CardBody style={{ padding: '50px 60px', paddingTop: 40, boxSizing: 'border-box' }}>
        <WorldsBestShapingPanel />
      </CardBody>
      <CardFooter />
      <CardHeader>
        <CardTitle text="Discover Honeylove" />
      </CardHeader>
      <CardBody>
        <DiscoverHoneylove />
      </CardBody>
      <CardFooter />
      <CardHeader>
        <CardTitle text="Featured" />
      </CardHeader>
      <CollectionCards></CollectionCards>
      <CardHeader>
        <CardTitle text="Why Honeylove" />
      </CardHeader>
      <CardBody>
        <WhyHoneylove />
      </CardBody>
      <CardFooter />
      <CardHeader>
        <CardTitle>
          <div>
            <Link
              href="https://www.instagram.com/honeylove/?hl=en"
              target="_blank"
              dataTrackLabel="Honeylove Instagram"
              dataTrackLocation="homepage"
              buttonType="ghost"
              labelStyleOptions={{ color: '#6361e8' }}
              text="@honeylove"
            />{' '}
            IRL
          </div>
        </CardTitle>
      </CardHeader>
      <CardBody>
        <HoneyloveIRL />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default HomeLanderDesktop;
